<script setup>
import { computed, defineProps, defineEmits, ref } from 'vue'

defineProps([
  'id',
  'label',
  'loading',
  'errors',
  'type',
  'maxCharacters',
  'required',
])
const emit = defineEmits(['update:modelValue'])
const val = ref('')
const handleInput = () => emit('update:modelValue', val.value)

const characterCount = computed(() => val.value.length)
</script>

<template>
  <div :class="{ 'has-error': errors }">
    <label
      :for="id"
      class="block text-sm font-medium text-gray-700"
      :class="{ 'after:content-[\'*\'] after:pl-1': required }"
    >
      {{ label }}
    </label>

    <div class="mt-1 rounded-md shadow-sm">
      <textarea
        v-if="type == 'textarea'"
        :id="id"
        v-model="val"
        @input="handleInput"
        class="shadow-sm block w-full sm:text-sm rounded-md focus:outline-none"
        :class="
          errors
            ? '!border-red-300 focus:ring-red-500 focus:!border-red-500'
            : '!border-gray-300 focus:ring-gray-500 focus:!border-gray-500'
        "
        type="text"
        :disabled="loading"
        rows="4"
        :maxlength="maxCharacters"
      ></textarea>
      <input
        v-else
        :id="id"
        v-model="val"
        @input="handleInput"
        class="shadow-sm block w-full sm:text-sm rounded-md focus:outline-none"
        :class="
          errors
            ? '!border-red-300 focus:ring-red-500 focus:!border-red-500'
            : '!border-gray-300 focus:ring-gray-500 focus:!border-gray-500'
        "
        type="text"
        :disabled="loading"
      />
    </div>

    <div class="flex justify-between">
      <slot name="errors"></slot>
      <div
        v-if="maxCharacters"
        class="flex justify-end font-medium text-xs text-gray-700 mt-1"
      >
        {{ characterCount }} von {{ maxCharacters }} Zeichen
      </div>
    </div>
  </div>
</template>
